import Meenat from '../images/meenat.jpg';
import { Typography, Grid, Box, useMediaQuery, styled} from '@mui/material';
import { Icon } from '@iconify/react';
import styled1, {keyframes} from 'styled-components';

// variables
const primary_color = "black";
const primary_color2 = "#696969";

//

const Container =styled(Box)(({theme}) => ({
        marginLeft: '20%',
        marginRight: '20%',
        justifyContent: 'center',
    })
    );

const ImageStyle = styled("img")`
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: 400px;
    width: 270px;
    // border-radius: 50%;
`;

const SlideIn = keyframes`
    from {
        margin-right: 0%;
        width: 200%;
    }
    to {
        margin-right: 100%;
        width: 100%;
    }
`;

const AboutAniation = styled1.h3`
    animation-name: ${SlideIn};
    animation-duration: 2s;
    font-family: Montserrat;
    font-weight: 900;
    font-size: 45px;
    // margin-bottom: 10px;
`;

const IconStyles = styled(Icon)`
    color: ${primary_color};
    font-size: 55px;
    border-right: 2px solid #d3d3d3;
    height: 30px;
    padding-right: 14px;
    &:hover {
        cursor: pointer;
        font-size: 50px;
        color: ${primary_color2};
    }
`;

const Test = styled(Grid)`
    display: 'inline';
    border:'2px black solid';
`;


    const About =()=>{
        //
        const mediaQuery = useMediaQuery('(min-width:1024px)');

        return(
            <>
             { mediaQuery ?
                <Container sx={{ paddingLeft:'20px', marginTop:'10%'}}>
                    <Grid container direction="row" justify="center" spacing={2}>
                        {/* <Grid item xs={mediaQuery ? 7 : 20 }> */}

                       <Test item  xs={mediaQuery ? 7 : null } >
                            <AboutAniation>
                                        <div>
                                            <Typography>
                                                <h2>Product & Engineering &#127919;</h2>
                                            </Typography>
                                            <Typography sx={{fontSize:'18px', lineHeight:'2', marginTop:"20px", fontFamily:'Oswald'}}>
                                                <p style={{fontSize:'30px', color:'#708090'}}>Empowering Everyday Experiences:</p>
                                                <p>
                                                    I find satisfaction in creating impactful
                                                    digital solutions that simplify lives. My approach involves meaningful contributions,
                                                    harmonizing technology capabilities with user needs and business goals for resonant innovation.
                                                </p>

                                            </Typography>
                                            <div style={{float:'left', justifyContent:'space-between'}}>
                                    <span>
                                        <a target="_blank" rel="noopener noreferrer" href='https://github.com/meenatt'>
                                            <IconStyles
                                            icon="icon-park:github"
                                            />
                                        </a>
                                    </span>
                                    <span style={{paddingLeft:'7px'}}>
                                        <a target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com/in/aminatfowokebalogun/'>
                                            <IconStyles
                                            icon="bxl:linkedin-square"
                                            />
                                        </a>
                                    </span>
                                    <span style={{paddingLeft:'12px'}}>
                                        <a target="_blank" rel="noopener noreferrer" href='https://mobile.twitter.com/bhalow_meenat'>
                                            <IconStyles
                                                icon="codicon:twitter"
                                                // style={{borderRight: `2px solid ${secondary_color}`}}
                                            />
                                        </a>
                                    </span>
                                    <span style={{paddingLeft:'12px'}}>
                                        <a target="_blank" rel="noopener noreferrer" href='https://youtube.com/@aminatfowokebalogun?si=3W5u1teZK4jh1_HF'>
                                            <IconStyles
                                                icon="material-symbols-light:youtube-activity"
                                            
                                            />
                                        </a>
                                    </span>
                                    
                                </div>
                                        </div>
                            </AboutAniation>
                                 <Grid item xs={5}>
                                    <ImageStyle alt='meenat' src={Meenat} />
                                </Grid>
                       </Test>

                        </Grid>
                    </Container>
                :
                <div style={{paddingTop:"20%"}}>
                        <AboutAniation>
                            <div>
                                <Typography>
                                     <h2>Product & Engineering &#127919;</h2>
                                </Typography>

                                <Typography sx={{fontSize:'18px', lineHeight:'2', marginTop:"20px", fontFamily:'Oswald', margin:'10px'}}>
                                    <p style={{fontSize:'30px', color:'#708090'}}>Empowering Everyday Experiences:</p>
                                    I find satisfaction in creating impactful
                                    digital solutions that simplify lives. My approach involves meaningful contributions,
                                    harmonizing technology capabilities with user needs and business goals for resonant innovation.
                                </Typography>
                                <div style={{float:'left', justifyContent:'space-between'}}>
                                    <span>
                                        <a target="_blank" rel="noopener noreferrer" href='https://github.com/meenatt'>
                                            <IconStyles
                                            icon="icon-park:github"
                                            />
                                        </a>
                                    </span>
                                    <span style={{paddingLeft:'7px'}}>
                                        <a target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com/in/aminatfowokebalogun-2aa8231ab'>
                                            <IconStyles
                                            icon="bxl:linkedin-square"
                                            />
                                        </a>
                                    </span>
                                    <span style={{paddingLeft:'12px'}}>
                                        <a target="_blank" rel="noopener noreferrer" href='https://mobile.twitter.com/bhalow_meenat'>
                                            <IconStyles
                                                icon="codicon:twitter"
                                                // style={{borderRight: `2px solid ${secondary_color}`}}
                                            />
                                        </a>
                                    </span>
                                    {/* <span style={{paddingLeft:'12px'}}>
                                        <a target="_blank" href='https://youtube.com/@aminatfowokebalogun?si=3W5u1teZK4jh1_HF'>
                                            <IconStyles
                                                icon="material-symbols-light:youtube-activity"
                                            
                                            />
                                        </a>
                                    </span> */}
                                </div>
                                        </div>
                            </AboutAniation><br/><br/>
                                 <Grid item xs={5}>
                                    <ImageStyle alt='meenat' src={Meenat} />
                                </Grid>
                                </div>


                    }


            </>
        )
    }

export default About;
